export default __webpack_public_path__ + "static/media/loader.f4d77e28.svg";